import Ajv from 'ajv';
import { pddSchema } from '../../domain/forms/schemas';
const ajv = new Ajv();
const schemaMap = {
    PDD: pddSchema,
};
export const validateFormData = (type, data) => {
    const schema = schemaMap[type];
    const validate = ajv.compile(schema);
    const isValid = validate(data);
    return {
        isValid,
        errors: validate.errors || [],
    };
};
